<template>
  <div class="aw-footer-wrap">
    <div class="aw-footer">
      © {{$t('common.bottomTitle')}}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {},
  watch: {}
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/bottom-title.vue